export default __webpack_public_path__ + "static/media/top-ten-9.ba158180.svg";